//import HomeProjects from 'components/HomeProjects';
//import Page from 'components/Page';
import TOBOPage from 'components/tobo/TOBOPage';
import TOBOSplash from 'components/tobo/TOBOSplash';

const HomePage = () => {
  return (
    <TOBOPage>
      {/* <HomeProjects /> */}
      <TOBOSplash />
    </TOBOPage>
  )
}

export default HomePage;
